import React, { useState, useCallback, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  Modal,
  ModalBody,
  Spinner,
  UncontrolledAlert,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import MyCurrencies from "./MyCurrencies";
import MyPortfolio from "./MyPortfolio";
import Trading from "./Trading";
import Widgets from "./Widgets";
import { toast } from "react-toastify";
import { APIClient } from "../../helpers/api_helper";

const apiClient = new APIClient();

const DashboardCrypto = () => {
  const user = JSON.parse(localStorage.getItem("authUser"));
  const [modal_center, setmodal_center] = useState(false);
  const tog_center = useCallback(() => {
    setmodal_center(!modal_center);
    localStorage.setItem("show_warning", "false");
  }, [modal_center]);

  document.title = "Painel Cliente | Painel Fort Exchange";
  const [cryptoWidgets, setSaldos] = useState([
    {
      id: 1,
      icon: "ri-money-dollar-circle-fill",
      label: "Conta Principal",
      counter: "0",
      badge: "ri-arrow-up-s-fill",
      badgeColor: "success",
      decimal: "2",
      prefix: "R$ ",
      separator: ",",
    },
    {
      id: 2,
      icon: "ri-money-dollar-circle-fill",
      label: "Subcontas",
      counter: "0",
      badge: "ri-arrow-up-s-fill",
      badgeColor: "success",
      decimal: "2",
      prefix: "R$ ",
      separator: ",",
    },
    {
      id: 3,
      icon: "ri-money-dollar-circle-fill",
      label: "Total R$",
      counter: "0",
      badge: "ri-arrow-up-s-fill",
      badgeColor: "success",
      decimal: "2",
      prefix: "R$ ",
      separator: ",",
    },
  ]);
  const [loading, setLoading] = useState(true);
  const [contas, setContas] = useState([]);
  const [coins, setCoins] = useState([]);
  const [fetchData, setFetch] = useState(true);

  const checkTime = () => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    const currentTimeInMinutes = hours * 60 + minutes;
    const startInterval = 9 * 60 + 45; // 9:45 convertido para minutos
    const endInterval = 10 * 60 + 15; // 10:15 convertido para minutos

    return (
      currentTimeInMinutes >= startInterval &&
      currentTimeInMinutes <= endInterval
    );
  };

  const blockedTime = checkTime();

  const fetchPrices = useCallback(async () => {
    const response = await apiClient.get("/moedas/precos");

    if (response.sucesso) {
      setCoins(response.dados);
    } else {
      toast.error(response.mensagem);
      console.log(response);
    }
  }, []);

  const formatCurrency = (value) => {
    if (!value) {
      return "R$ 0,00";
    }
    try {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    } catch (error) {
      return "R$ 0,00";
    }
  };

  const getSaldos = useCallback(async () => {
    setLoading(true);
    await fetchPrices();
    const clientData = JSON.parse(localStorage.getItem("authUser") || "{}");
    const userId = clientData.data._id ? clientData.data._id : 0;

    const response = await apiClient.get(`/cripto-td/contas/saldos/${userId}`);

    if (response.sucesso) {
      let temp = cryptoWidgets;
      temp[0].counter = response.dados.saldo_principal.toString();
      temp[1].counter = response.dados.saldo_subcontas.toString();
      temp[2].counter = (
        response.dados.saldo_subcontas + response.dados.saldo_principal
      ).toString();
      setContas(response.dados.contas);
      setSaldos(temp);
    } else {
      toast.error(response.mensagem);
    }

    setLoading(false);
    setFetch(false);
  }, [cryptoWidgets, fetchPrices]);

  useEffect(() => {
    const _fetchData = async () => {
      await getSaldos();
    };

    if (fetchData) _fetchData();
  }, [getSaldos, fetchData, coins]);

  if (user.data.role === "Lojista") {
    window.location.href = "/perfil-lojista";
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: "20px",
        }}
      >
        <Spinner height={100} width={100} />
      </div>
    );
  } else if (parseInt(user.data.clientData.nivel_kyc) === 0) {
    window.location.href = "/profile";
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: "20px",
        }}
      >
        <Spinner height={100} width={100} />
      </div>
    );
  } else
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <BreadCrumb title="Painel" pageTitle="Clientes Fort" />
            {modal_center && (
              <UncontrolledAlert color="danger" className="text-center p-4">
                <h4 className="mb-3">Atenção! Risco de perda de ativos!</h4>
                <p className="text-warning-light mb-4">
                  {" "}
                  Se você tem alguma conta de ETH ou POL,{" "}
                  <b className="text-warning">
                    não utilize carteiras de exchange
                  </b>{" "}
                  para receber os valores. Exchanges dificilmente rastreiam a
                  entrada desses ativos via MULTISEND.
                </p>
                <p className="text-danger mb-4">
                  <b>
                    UMA EXCHANGE PODE NEGAR A ENTRADA DESSAS MOEDAS QUANDO
                    ENVIADO POR MULTISEND!
                  </b>
                </p>
                <p className="text-warning-light mb-4">
                  Se a carteira que você está usando para ETH e POL é de sua
                  posse mesmo,{" "}
                  <b className="text-warning">
                    apenas fique ciente de que a transação de envio é uma
                    transação interna
                  </b>
                  . Ou seja, embora você receba normalmente os seus tokens e seu
                  saldo aumente, o aplicativo da sua carteira pode não exibir a
                  transação.
                </p>
                <Button color="danger" onClick={tog_center}>
                  Clique aqui se entendeu
                </Button>
              </UncontrolledAlert>
            )}
            <Row>
              <MyPortfolio
                contas={contas}
                loading={loading}
                coins={coins}
                saldos={cryptoWidgets}
                formatCurrency={formatCurrency}
              />
              <Col className="order-xxl-0 order-first">
                <Row>
                  <Widgets
                    cryptoWidgets={cryptoWidgets}
                    loading={loading}
                    coins={coins}
                    setFetch={setFetch}
                  />
                  <MyCurrencies
                    contas={contas}
                    loading={loading}
                    coins={coins}
                    setContas={setContas}
                    formatCurrency={formatCurrency}
                    blockedTime={blockedTime}
                  />
                  <Trading
                    coins={coins}
                    contas={contas}
                    loading={loading}
                    saldos={cryptoWidgets}
                    setFetch={setFetch}
                    setLoading={setLoading}
                    formatCurrency={formatCurrency}
                    tog_center={tog_center}
                    blockedTime={blockedTime}
                  />
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
};

export default DashboardCrypto;
